// Bucket taxonomy — must match backend BUCKETS list
export const BUCKETS = [
  {
    key: "wedding",
    label: "The Big Day",
    micro: "January 24, 2021 — the paperwork of forever.",
    intro: "January 24, 2021. The day Perk signed up for a lifetime of reheated coffee. Bob just showed up looking devastating. Iconic.",
  },
  {
    key: "funny",
    label: "Certified Chaos",
    micro: "The face. The pose. The unpredictable expressions.",
    intro: "Photographic evidence that she cannot hold a normal expression for longer than 3.2 seconds. Bilkul unpredictable, always iconic.",
  },
  {
    key: "sweet",
    label: "Soft Moments",
    micro: "The parts we don't roast (much).",
    intro: "The quiet frames. The ones we don't roast. Yahan Bob's soft side comes out to play — proceed with heart intact.",
  },
  {
    key: "eating",
    label: "Foodie Files",
    micro: "Pani puri • peri peri fries • softy • Crumbl loyalist.",
    intro: "A shrine to the food groups she considers sacred: pani puri (round two mandatory), softy, Crumbl, peri peri fries. Mithai does not appear here. It's not allowed.",
  },
  {
    key: "sleepy",
    label: "Doom-Scroll HQ",
    micro: "Blanket burrito, phone glow, '10 more mins' since 2021.",
    intro: "Filmed at 1:14 AM. Blanket-burrito activated. Phone glow: constant. 'Ten more minutes' since 2021. Chalo Bob, sleep now.",
  },
  {
    key: "mom_mode",
    label: "Mom Mode ft. Via",
    micro: "The boss of the boss of the house.",
    intro: "Ft. Via — the CEO of the household. Bob is now his personal chef, chauffeur, and permanent hug station. Legend behaviour.",
  },
  {
    key: "with_perk",
    label: "With Perk",
    micro: "Two overthinkers, one shared reheated coffee.",
    intro: "Two overthinkers, one reheated coffee, and an AC remote they fight over daily. Ekdum team perfect. Nazar na lage.",
  },
  {
    key: "with_pista",
    label: "With Pista",
    micro: "Chief instigator meets primary target.",
    intro: "The certified sibling duo. Chief instigator meets favourite target. Every photo has a story, and Pista has the receipts.",
  },
  {
    key: "dressed_up",
    label: "Dressed To The Nines",
    micro: "Kurta, saree, glam looks. Festive Bob activated.",
    intro: "Kurtas, sarees, glam looks. Woh 'ready in five minutes' bola tha, but arrived 90 minutes later looking absolutely sensational.",
  },
  {
    key: "party_dance",
    label: "Dance Floor",
    micro: "Cocktails, sparklers, one song turned ten.",
    intro: "One song promised. Ten songs delivered. Sparklers, spins, and the DJ knows her name by now. Chalo ab masti.",
  },
  {
    key: "mountains",
    label: "Mountain Bob",
    micro: "Cold air, warm jackets, warmer heart.",
    intro: "Cold air, warm jackets, warmer heart. Even at altitude she was probably asking where the pani puri stall is.",
  },
  {
    key: "girls_gang",
    label: "Girls' Gang",
    micro: "The friends, the giggles, the receipts.",
    intro: "The girls. The giggles. The 'don't post that one' negotiations happening in real-time. Bhabhijaan energy — respect the receipts.",
  },
  {
    key: "family_travel",
    label: "Family & Travel",
    micro: "The clan on tour.",
    intro: "The whole clan on tour. Passports out, snacks packed, Bob leading the itinerary like an army general with a heart of gold.",
  },
  {
    key: "throwback",
    label: "Throwback Tapes",
    micro: "Baby Bob, teen Bob, pre-Perk era.",
    intro: "Baby Bob. Teen Bob. Pre-Perk Bob. The origin story. Warning: contains excessive cuteness and one questionable hairstyle.",
  },
  {
    key: "video_reels",
    label: "Video Reels",
    micro: "Roll the tape. All Bob, all the time.",
    intro: "Roll the tape. Zero editing. Full personality. Yeh dekho, this is what Bob is like when the family camera is rolling.",
  },
  {
    key: "milestones",
    label: "Milestones",
    micro: "The 'save-this-forever' shots.",
    intro: "The 'save-this-forever' shots. Awards, achievements, and quiet wins the family always got loud about. Bahut proud, always.",
  },
];

export const BUCKET_MAP = Object.fromEntries(BUCKETS.map((b) => [b.key, b]));

export const BUCKET_ACCENTS = {
  wedding: "#7B9ACC",
  funny: "#A7C7E7",
  sweet: "#D6E4F0",
  eating: "#7B9ACC",
  sleepy: "#334E68",
  mom_mode: "#A7C7E7",
  with_perk: "#7B9ACC",
  with_pista: "#A7C7E7",
  dressed_up: "#7B9ACC",
  party_dance: "#A7C7E7",
  mountains: "#334E68",
  girls_gang: "#A7C7E7",
  family_travel: "#D6E4F0",
  throwback: "#334E68",
  video_reels: "#7B9ACC",
  milestones: "#7B9ACC",
};
